<div class="card">
  <div class="card-body">
    <ng-container *ngTemplateOutlet="InvoiceTemplateSituationDelegation"></ng-container>
  </div>
</div>

<ng-template #InvoiceTemplateSituationDelegation>
  <div fxLayout="column">
    <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px">
      <div class="card-header-detail">D&Eacute;L&Eacute;GATAIRE :</div>
      <button mat-icon-button color="accent" (click)="addDelegation()" *ngIf="!isReadOnlyForm">
        <mat-icon>add_circle</mat-icon>
      </button>
    </div>

    <div fxLayout="row" fxFlex="100" fxLayoutAlign="center" fxLayoutGap="10px">
      <ng-container *ngTemplateOutlet="InvoiceTemplateDelegationDetail"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #InvoiceTemplateDelegationDetail>
  <form [formGroup]="invoiceDetailForm" fxLayout="column" fxFlex="100" fxLayoutAlign="start">
    <ng-container formArrayName="InvoiceDelegations">
      <div fxLayout="column" fxFlex="100" fxLayoutAlign="start">
        <ng-container *ngFor="let delegationForm of InvoiceDelegations.controls; let i = index">
          <div class="delegation-form-row" [formGroup]="delegationForm" fxLayout="column" fxFlex="100" fxLayoutAlign="start">
            <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px" [ngClass]="InvoiceDelegations.length == (i+1) ? 'customWrapper' : 'customDefaultWrapper'">
              <div fxFlex="34" fxFlex.gt-sm="34" fxLayoutGap="10px">
                <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100" *ngIf="delegationForm.controls['DelegateName'].disabled">
                  <mat-label>D&Eacute;L&Eacute;GATAIRE </mat-label>
                  <input matInput formControlName="DelegateName" type="text" readonly>
                </mat-form-field>
                <div class="dropDownStyle" *ngIf="! delegationForm.controls['DelegateName'].disabled" fxFlex="100">
                  <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" floatLabel="always">
                    <mat-label>D&Eacute;L&Eacute;GATAIRE </mat-label>
                    <input matInput formControlName="DelegateName" type="text" hidden>
                    <ng-multiselect-dropdown [ngClass]="{ 'edited-color': editedDropdowns.includes('ExpenseVat') }" formControlName="DelegateName" placeholder='Sélectionner'
                      [settings]="dropDownSettingsDelegates" [data]="delegates" (onFilterChange)="onFilterChangeDelegates($event)" [ngModel]="delegationForm.controls.DelegateName.value"
                      (onSelect)="onChangeDelegateName(i, delegationForm.controls.CreatedAt.value, $event)" (onDeSelect)="onChangeDelegateName(i, delegationForm.controls.CreatedAt.value, null)"
                      ngDefaultControl>
                    </ng-multiselect-dropdown>
                  </mat-form-field>
                </div>
              </div>
              <div fxFlex="34" fxFlex.gt-sm="34" fxLayoutGap="10px">
                <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100" *ngIf="delegationForm.controls['CreditorName'].disabled">
                  <mat-label>CR&Eacute;ANCIER </mat-label>
                  <input matInput formControlName="CreditorName" type="text" readonly>
                </mat-form-field>
                <div class="dropDownStyle" *ngIf="! delegationForm.controls['CreditorName'].disabled" fxFlex="100">
                  <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" floatLabel="always">
                    <mat-label>CR&Eacute;ANCIER </mat-label>
                    <input matInput formControlName="CreditorName" type="text" hidden>
                    <ng-multiselect-dropdown [ngClass]="{ 'edited-color': editedDropdowns.includes('CreditorName') }" formControlName="CreditorName" placeholder='Sélectionner'
                      [settings]="dropDownSettingsCreditors" [data]="creditors" (onFilterChange)="onFilterChangeCreditors($event)" [ngModel]="delegationForm.controls.CreditorName.value"
                      (onSelect)="onChangeCreditorName(i, delegationForm.controls.CreatedAt.value, $event)" (onDeSelect)="onChangeCreditorName(i, delegationForm.controls.CreatedAt.value, null)"
                      ngDefaultControl>
                    </ng-multiselect-dropdown>
                  </mat-form-field>
                </div>
              </div>
              <div fxFlex="20" fxFlex.gt-sm="20" fxLayoutGap="10px">
                <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
                  <mat-label>MONTANT TTC </mat-label>
                  <input matInput formControlName="DelegateAmountRemainsTaxIncluded" type="text" decimalFormat pattern="[0-9\s+]+([,\.][0-9]{0,2})?" step="0.01">
                </mat-form-field>
              </div>
              <div fxFlex="10" fxFlex.gt-sm="10" fxLayoutGap="10px">
                <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
                  <mat-label>FORFAIT TTC </mat-label>
                  <input matInput formControlName="DelegateAmountPackageTaxIncluded" type="text" decimalFormat pattern="[0-9\s+]+([,\.][0-9]{0,2})?" step="0.01">
                </mat-form-field>
              </div>
              <div fxFlex="2" fxFlex.gt-sm="2">
                <button mat-icon-button color="accent" (click)="deleteDelegation(i, delegationForm.controls.CreatedAt.value)" *ngIf="!isReadOnlyForm">
                  <mat-icon>remove_circle</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </form>
</ng-template>